import React from 'react'
import styles from './TimesCard.module.scss'

const TimeItem = (props) => {

	const classes=[styles.Item];
	if(props.active){
		classes.push(styles.Active)
	}
	return (

		<div className={classes.join(' ')} onClick={props.onClick}  >
			<span >{`${props.timeRange.start_at} - ${props.timeRange.end_at}`}</span>
		</div>
	)
}

export default TimeItem
